import { useRef } from 'react';
import isEqual from 'lodash.isequal';

var useStableObject = function useStableObject(obj) {
  var holder = useRef(obj);

  if (obj !== holder.current && !isEqual(obj, holder.current)) {
    holder.current = obj;
  }

  return holder.current;
};

export { useStableObject as u };